import React from 'react';
import { Label, Row, Col, FormGroup, Button, Alert, Input } from 'reactstrap';
import SelectComponent from '@componentes/select/select.component';
import Switch from 'react-switch';
import '../../configuracao.style.css';
import IntlMessage from '../../../../../src/helpers/intlMessage';
import { useIntl } from 'react-intl';

const ConfiguracoesGeraisPage = props => { 
  
  const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}

  return (
  <div
    style={{
      height: `${props.altura}px`,
      width: '100%',
      overflowY: 'scroll',
      overflowX: 'hidden'
    }}
  >
    <div className='config-item'>
      <Row>
        <Col sm='auto'>
          <Label><IntlMessage id = "dashboards.general.personalizedExam"/></Label>
        </Col>
        <Col>
          <Switch onChange={props.toggleSwitch} checked={props.switchValor} />
        </Col>
      </Row>
      <Row className='config-nrexame-personalizado'>
        <Col>
          <FormGroup>
            <Label><IntlMessage id = "dashboards.general.initials"/></Label>
            <SelectComponent
              options={props.ordenacao}
              value={props.posicaoSigla}
              placeholder={translate("dashboards.general.selectInitials")}
              disabled={!props.switchValor}
              onChange={event => props.onChangeSelect('posicaoSigla', event)}
              isOptionDisabled={option =>
                props.posicoesJaSelecionadas.indexOf(option.value) > -1
              }
            />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label><IntlMessage id = "dashboards.general.sequence"/></Label>
            <SelectComponent
              options={props.ordenacao}
              value={props.posicaoSequencia}
              placeholder={translate("dashboards.general.selectSequence")}
              disabled={!props.switchValor}
              onChange={event =>
                props.onChangeSelect('posicaoSequencia', event)
              }
              isOptionDisabled={option =>
                props.posicoesJaSelecionadas.indexOf(option.value) > -1
              }
            />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label><IntlMessage id = "dashboards.general.currentYear"/></Label>
            <SelectComponent
              options={props.ordenacao}
              value={props.posicaoAno}
              placeholder={translate("dashboards.general.selectCurrentYear")}
              disabled={!props.switchValor || !props.valorAno}
              onChange={event => props.onChangeSelect('posicaoAno', event)}
              isOptionDisabled={option =>
                props.posicoesJaSelecionadas.indexOf(option.value) > -1
              }
            />
          </FormGroup>
        </Col>
        <Col sm='1'>
          <FormGroup className='input-sem-label'>
            <Input
              type='number'
              className='borda-arredondada'
              value={props.valorAno}
              disabled={!props.switchValor}
              onChange={e =>
                props.onChangeInput('valorAno', e.currentTarget.value)
              }
            />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label><IntlMessage id = "dashboards.general.separator"/></Label>
            <SelectComponent
              options={props.ordenacao}
              value={props.posicaoSeparador}
              placeholder={translate("dashboards.general.selectSeparator")}
              disabled={!props.switchValor || !props.valorSeparador}
              onChange={event =>
                props.onChangeSelect('posicaoSeparador', event)
              }
              isOptionDisabled={option =>
                props.posicoesJaSelecionadas.indexOf(option.value) > -1
              }
            />
          </FormGroup>
        </Col>
        <Col sm='1'>
          <FormGroup className='input-sem-label'>
            <Input
              className='borda-arredondada'
              value={props.valorSeparador}
              disabled={!props.switchValor}
              onChange={e =>
                props.onChangeInput('valorSeparador', e.currentTarget.value)
              }
            />
          </FormGroup>
        </Col>
        <Col sm='auto'>
          <Button
            className='exame-personalidado-button'
            color='warning'
            disabled={!props.switchValor}
            onClick={props.zerarCampos}
          >
            <IntlMessage id = "dashboards.examDetail.clearFields"/>
          </Button>
        </Col>
      </Row>
      {props.switchValor && (
        <Row>
          <Col>
            <Alert color='success' className='exame-personalizado-alerta'>
              <IntlMessage id = "dashboards.general.exampleNumber"/>
              <span>{props.exemploNumeroExamePersonalizado}</span>
            </Alert>
          </Col>
        </Row>
      )}
    </div>
    <div className='config-item'>
      <Row>
        <Col sm='auto'>
          <Label><IntlMessage id = "dashboards.general.resultExam"/></Label>
        </Col>
        <Col>
          <Switch
            onChange={props.switchValorImprimirProtocolo}
            checked={props.imprimirProtocoloEntrega === 'S'}
          />
        </Col>
      </Row>
    </div>
    <div className='config-item'>
      <Row>
        <Col sm='auto'>
          <Label><IntlMessage id = "dashboards.general.printStep"/></Label>
        </Col>
        <Col>
          <Switch
            onChange={props.switchAgruparLaudo}
            checked={props.agruparLaudos === 'S'}
          />
        </Col>
      </Row>
    </div>
    <div className='config-item'>
      <Row>
        <Col sm='auto'>
          <Label><IntlMessage id = "dashboards.general.stepNameNotes"/></Label>
        </Col>
        <Col xs={2}>
          <Input
            required
            pattern={/^[A-Z]{3,8}$/i}
            onChange={e => props.alterarNomeNotas(e.target.value)}
            value={props.nomeNotas}
          />
        </Col>
      </Row>
    </div>
    <Button
      className='exame-personalidado-button'
      color='primary'
      onClick={props.gravarConfiguracoesGerais}
    >
      <IntlMessage id = "dashboards.examDetail.save"/>
    </Button>
  </div>
);
}

export default ConfiguracoesGeraisPage;



// WEBPACK FOOTER //
// ./src/pages/configuracao/tab/geral/geral.page.js